import React from "react";
import { useAuth } from "../context/AuthContext";

const TAB_ICONS = {
  // Super Admin
  overview: "📊",
  schools: "🏫",
  plans: "💳",
  templates: "📋",
  revenue: "💰",
  // School Admin
  dashboard: "🏠",
  classes: "🏫",
  students: "👥",
  teachers: "👨‍🏫",
  assignments: "📌",
  exams: "📝",
  marks_entry: "✏️",
  class_view: "📋",
  publication: "📢",
  reports: "📊",
  export: "🖨️",
  promotion: "🏆",
  result_template: "🎨",
  branding: "🏷️",
  result_settings: "⚙️",
  attendance: "📅",
  admin_remarks: "💬",
  settings: "🔧",
  // Teacher
  marks: "✏️",
  myassignments: "📌",
  remarks: "💬",
  profile: "👤",
  ct_students: "👥",
};

function getExpiryBadge(user) {
  if (!user?.subscriptionExpiresAt) return null;
  const exp = new Date(user.subscriptionExpiresAt);
  const now = new Date();
  const daysLeft = Math.ceil((exp - now) / (1000 * 60 * 60 * 24));

  if (daysLeft < 0) {
    return <div className="sidebar-expiry-badge expired">Subscription expired</div>;
  }
  if (daysLeft <= 14) {
    return <div className="sidebar-expiry-badge warn">Expires in {daysLeft}d</div>;
  }
  return <div className="sidebar-expiry-badge ok">Active — {daysLeft}d left</div>;
}

export default function Sidebar({ title, tabs, activeTab, onTabChange }) {
  const { user, logout } = useAuth();

  return (
    <div className="sidebar">
      {/* Brand */}
      <div className="sidebar-brand">
        <div className="logo-on-dark">
          <img src="/logo.png" alt="VRM" className="logo-img-sm" />
        </div>
        <div>
          <div className="sidebar-brand-text">VRM System</div>
          <div className="sidebar-brand-unit">Volcanic Education &amp; Technology</div>
        </div>
      </div>

      {/* Role label */}
      <div className="sidebar-section-label">{title}</div>

      {/* Navigation */}
      <nav>
        {tabs.map((t) => (
          <button
            key={t.key}
            className={`sidebar-item${activeTab === t.key ? " active" : ""}`}
            onClick={() => onTabChange(t.key)}
          >
            <span className="sidebar-item-icon">
              {TAB_ICONS[t.key] || "•"}
            </span>
            {t.label}
          </button>
        ))}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        {getExpiryBadge(user)}
        <div className="sidebar-user-name">{user?.name || "User"}</div>
        <div className="sidebar-user-role">{(user?.role || "").replace("_", " ")}</div>
        <button
          className="btn secondary sm"
          style={{ width: "100%" }}
          onClick={logout}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}
